import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { MpjobService } from 'src/app/services/jobs/mpjob.service';
import { ActivatedRoute, Router } from '@angular/router';
import * as _ from 'lodash'
import { MedicalFromService } from 'src/app/services/medical-from.service';
import { Observable } from 'rxjs';
import { MatSnackBar, MatDialog } from '@angular/material';
import { MedicalStatusComfirmModalComponent } from './medical-status-comfirm-modal/medical-status-comfirm-modal.component';
import { mpFormPartsArray, medicalResultArray } from '../../_models/staticArray'
import { DownloadService } from '../../services/download.service'
import { UtilityService } from '../../services/utility.service'
import { saveAs } from "file-saver";
@Component({
  selector: 'app-medical-status',
  templateUrl: './medical-status.component.html',
  styleUrls: ['./medical-status.component.scss']
})
export class MedicalStatusComponent implements OnInit {
  candidates: any;
  candidateStatus: any = [];
  jobId: any;
  hoverIndex: any;
  selectedCandidates;
  results = medicalResultArray
  formParts = mpFormPartsArray
  noDataMsg = {
    title: "No Candidates!",
    data: "You have not yet assigned any candidates"
  }
  candidatesCopy: any;
  candidateStatusCopy: any = [];
  loading: boolean;
  statusUsers = []
  alcoholUsers = []
  sentielUser = []
  candidatesForFilter: any;
  user: any;
  trackerArray = []

  @Input('jobId') jobFromClient;
  @Input('learnerAdded') newLearner;
  @Input('tracker') trackerData
  @Input('jobDetails') jobData
  @Input('jobTitle') jobTitle;
  @Input('job') job
  resultsArray = [];
  constructor(public _mpJobService: MpjobService, public activatedRoute: ActivatedRoute, public _utilityService: UtilityService, public _downloadService: DownloadService, public router: Router,
    public _medicalFormService: MedicalFromService, public dialog: MatDialog, public _snackBar: MatSnackBar) { }

  ngOnInit() {
    this.user = JSON.parse(localStorage.getItem('userRoles'))
    this.loading = true
    this.activatedRoute.params.subscribe(params => {
      console.log("Params", params)
      if (params.jobid) {
        this.jobId = params.jobid
      }
    })
    this.getCandidates()
    this.getCandidateMedicalStatus()
  }



  ngOnChanges(changes: SimpleChanges): void {
    console.log("single job details chabages", changes);

    if (changes.jobFromClient && changes.jobFromClient.currentValue) {
      this.jobId = changes.jobFromClient.currentValue
      console.log("what is the value of job==========", this.jobId);

      this.getCandidates()
      this.getCandidateMedicalStatus()
    }
    if (changes.newLearner && changes.newLearner.currentValue) {
      let learnerAdd = changes.newLearner.currentValue
      this.candidates.push(learnerAdd)
      // this.candidatesCopy.push(learnerAdd)
      let statusObj = {
        name: learnerAdd.name,
        uniqueNumber: learnerAdd.uniqueNumber,
        userId: learnerAdd.userId,
        colorAssesment: "Not-Done",
        generalHealth: "Not-Done",
        hearingAssesment: "Not-Done",
        noStatus: true,
        visionAssesment: "Not-Done"
      }
      this.candidateStatus.push(statusObj)
      // this.candidateStatusCopy.push(statusObj)
    }
    if (changes.trackerData && changes.trackerData.currentValue) {
      console.log("value of traacaker details=======", changes.trackerData.currentValue);


      this.trackerArray = changes.trackerData.currentValue
      if (this.trackerArray && this.trackerArray.length) {

        this.formParts = ['Result']
        if (this.trackerArray.includes('Medical')) {
          this.formParts.push('General Health')
          this.formParts.push('Vision Assessment')
          this.formParts.push('Hearing')
          this.formParts.push('Color Vision')
        }
        if (this.trackerArray.includes('Drugs')) {
          this.formParts.push('Drugs')
        }
        if (this.trackerArray.includes('Alcohol')) {
          this.formParts.push('Alcohol')
        }
        if (this.trackerArray.includes('Uploaded To Sentinel')) {
          this.formParts.push('Uploaded to sentinel')
        }
      } else {
        console.log("call this else paart or not=====");

        this.formParts = []
      }
    }
    console.log("final array of candidates=======", this.candidates);
    console.log("finala aarray of status", this.candidateStatus);
    if (changes.job && changes.job.currentValue) {
      this.job = changes.job.currentValue
    }
    if (changes.jobData && changes.jobData.currentValue) {
      console.log("first time load page dataaa", changes.jobData.currentValue);
      this.jobData = changes.jobData.currentValue


      this.trackerArray = changes.jobData.currentValue
      // console.log("value of data", this.trackerArray);

      if (this.trackerArray && this.trackerArray.length) {

        this.formParts = ['Result']
        if (this.trackerArray.includes('Medical')) {
          this.formParts.push('General Health')
          this.formParts.push('Vision Assessment')
          this.formParts.push('Hearing')
          this.formParts.push('Color Vision')
        }
        if (this.trackerArray.includes('Drugs')) {
          this.formParts.push('Drugs')
        }
        if (this.trackerArray.includes('Alcohol')) {
          this.formParts.push('Alcohol')
        }
        if (this.trackerArray.includes('Uploaded To Sentinel')) {
          this.formParts.push('Uploaded to sentinel')
        }
      } else {
        console.log("call this else paart or not=====");

        this.formParts = []
      }
    }

    if (changes.jobTitle && changes.jobTitle.currentValue) {
      this.jobTitle = changes.jobTitle.currentValue
    }
  }

  userIndex(i) {
    this.hoverIndex = i
  }
  userIndexChanged() {
    this.hoverIndex = -1
  }

  // redirect() {
  //   this.router.navigateByUrl('/medical-record/add/' + this.jobId)
  // }


  redirect(type) {
    if (type === 'medical') this.router.navigateByUrl('/medical-record/add/' + this.jobId)
    else if (type === 'poct') this.router.navigateByUrl('/medical-record/testPoct/' + this.jobId)
    else this.router.navigateByUrl('/medical-record/breathAlcohol/' + this.jobId)
  }

  markAsComplete(candidate, candidateIndex, event, type) {
    console.log('candidate', event.target.classList)

    if (event.target.classList[1] != 'selected') {
      $("#" + candidate.userId).addClass('selected');
      $("#" + candidate.userId).removeClass('td-height');
      let obj = {
        userId: candidate.userId,
        type: type
      }
      this.statusUsers.push(obj)
    }
    else {
      console.log("call this else part");

      $("#" + candidate.userId).removeClass('selected');
      $("#" + candidate.userId).addClass('td-height');

      let index = _.findIndex(this.statusUsers, function (o) { return o.userId == candidate.userId })
      if (index > -1) {
        this.statusUsers.splice(index, 1)
      }
    }
    console.log("DATA TO SEND", this.statusUsers);
  }
  markAsCompleteForAlcohol(candidate, index, event, type) {

    if (event.target.classList[1] != 'selected') {
      $("#alcohol-" + candidate.userId).addClass('selected');
      $("#alcohol-" + candidate.userId).removeClass('td-height');
      let obj = {
        userId: candidate.userId,
        type: type
      }
      this.alcoholUsers.push(obj)
    }
    else {
      console.log("run else...........")
      $("#alcohol-" + candidate.userId).removeClass('selected');
      $("#alcohol-" + candidate.userId).addClass('td-height');

      let index = _.findIndex(this.alcoholUsers, function (o) { return o.userId == candidate.userId })
      if (index > -1) {
        this.alcoholUsers.splice(index, 1)
      }
    }
  }

  markAsCompleteForSentinel(candidate, index, event, type) {

    if (event.target.classList[1] != 'selected') {
      $("#sentinel-" + candidate.userId).addClass('selected');
      $("#sentinel-" + candidate.userId).removeClass('td-height');
      let obj = {
        userId: candidate.userId,
        type: type
      }
      this.sentielUser.push(obj)
    }
    else {
      console.log("run else...........")
      $("#sentinel-" + candidate.userId).removeClass('selected');
      $("#sentinel-" + candidate.userId).addClass('td-height');

      let index = _.findIndex(this.sentielUser, function (o) { return o.userId == candidate.userId })
      if (index > -1) {
        this.sentielUser.splice(index, 1)
      }
    }
  }



  updateDnA() {

    console.log("list of drugs ans alcohol users", this.statusUsers);
    console.log("alcohol users", this.alcoholUsers);
    let data
    if ((this.statusUsers && this.statusUsers.length) && (this.alcoholUsers && !this.alcoholUsers.length)) {
      data = "Drugs"
    }
    if ((this.statusUsers && !this.statusUsers.length) && (this.alcoholUsers && this.alcoholUsers.length)) {
      data = "Alcohol"
    }
    if ((this.statusUsers && this.statusUsers.length) && (this.alcoholUsers && this.alcoholUsers.length)) {
      data = "Drugs & Alcohol"
    }
    // let data = "Drugs"
    this.openDialog(MedicalStatusComfirmModalComponent, data).subscribe(confirm => {
      console.log("what is in this confirm data", confirm);

      if (!confirm) {
        this.clearArray()
        this.clearAlcoholArray()
        this.clearSentialArray()
        return
      }
      else if (confirm.value == 'Yes' && confirm.status != undefined) {
        console.log("this.statusUsers to send to database", this.statusUsers)
        let finalArray = this.statusUsers.concat(this.alcoholUsers)
        let allSelectedUserArray = finalArray.concat(this.sentielUser)
        console.log("final array to send", finalArray);

        let obj = {
          allUsers: allSelectedUserArray,
          status: confirm.status,
          jobId: this.jobId
          // name: 'Drugs'
        }
        this.loading = true
        this._medicalFormService.updateStatus(obj).subscribe(res => {
          console.log("RES", res);
          this.clearArray()
          this.clearAlcoholArray()
          this.clearSentialArray()
          this.getCandidateMedicalStatus()
          this.loading = false
        })
      }
      else {
        this.clearArray()
        this.clearSentialArray()
        this.clearAlcoholArray()
      }
    })
  }


  updateAlcoholStatus() {
    console.log("all users list", this.alcoholUsers);
    let data = "Alcohol"
    this.openDialog(MedicalStatusComfirmModalComponent, data).subscribe(confirm => {
      console.log("what is in this confirm data", confirm);

      if (!confirm) {
        this.clearAlcoholArray()
        return
      }
      else if (confirm.value == 'Yes' && confirm.status != undefined) {
        console.log("this.statusUsers to send to database", this.alcoholUsers)
        let obj = {
          allUsers: this.alcoholUsers,
          status: confirm.status,
          name: 'Alcohol'
        }
        this._medicalFormService.updateStatus(obj).subscribe(res => {
          console.log("RES", res);
          this.clearAlcoholArray()
          this.getCandidateMedicalStatus()
        })
      }
      else {
        this.clearAlcoholArray()
      }
    })
  }

  clearAlcoholArray() {

    if (this.alcoholUsers && this.alcoholUsers.length) {
      this.alcoholUsers.forEach(user => {
        $("#alcohol-" + user.userId).removeClass('selected');
        $("#alcohol-" + user.userId).addClass('td-height');
      })
    }
    this.alcoholUsers = []
  }


  clearSentialArray() {

    if (this.sentielUser && this.sentielUser.length) {
      this.sentielUser.forEach(user => {
        $("#sentinel-" + user.userId).removeClass('selected');
        $("#sentinel-" + user.userId).addClass('td-height');
      })
    }
    this.sentielUser = []
  }


  clearArray() {
    if (this.statusUsers && this.statusUsers.length) {
      this.statusUsers.forEach(user => {
        $("#" + user.userId).removeClass('selected');
        $("#" + user.userId).addClass('td-height');
      })
    }
    this.statusUsers = []
  }

  resultChanged(event, candidate) {
    // console.log("EVENT", event, "candidate", candidate)
    let obj = {
      result: event.value,
      userId: candidate.userId
    }

    if (this.resultsArray.length) {
      let index = _.findIndex(this.resultsArray, function (o) { return o.userId == candidate.userId })
      if (index > -1) {
        this.resultsArray[index].result = event.value
      } else {
        this.resultsArray.push(obj)
      }
    } else {
      this.resultsArray.push(obj)
    }

    // console.table("RESULTS ARRAY IS", this.resultsArray)

    this.checkStatus(event, candidate)

  }

  checkStatus(event, candidate) {
    let result = event.value
    if (result.includes('D&A Only')) {
      let index = _.findIndex(this.candidateStatus, function (x) { return x.userId == candidate.userId })
      this.candidateStatus[index].generalHealth = 'Blacked'
      this.candidateStatus[index].visionAssesment = 'Blacked'
      this.candidateStatus[index].hearingAssesment = 'Blacked'
      this.candidateStatus[index].colorAssesment = 'Blacked'
    } else {
      let index1 = _.findIndex(this.candidateStatusCopy, function (x) { return x.userId == candidate.userId })
      this.candidateStatus[index1].generalHealth = this.filterOnStatus(result, this.candidateStatusCopy[index1], 'generalHealth')
      this.candidateStatus[index1].visionAssesment = this.filterOnStatus(result, this.candidateStatusCopy[index1], 'visionAssesment')
      this.candidateStatus[index1].hearingAssesment = this.filterOnStatus(result, this.candidateStatusCopy[index1], 'hearingAssesment')
      this.candidateStatus[index1].colorAssesment = this.filterOnStatus(result, this.candidateStatusCopy[index1], 'colorAssesment')
      // }
    }
  }

  filterOnStatus(result, data, type) {

    console.log("what is the result of it", result);
    console.log("this is the single candidate data", data);


    if (result && result.length && result.includes('D&A Only')) return 'Blacked'
    else {
      if (type == 'generalHealth') return (data && data.generalHealthComplete) ? "Done" : "Not-Done"
      else if (type == 'visionAssesment') return (data && data.visionComplete) ? "Done" : "Not-Done"
      else if (type == 'hearingAssesment') return (data && data.hearingComplete) ? "Done" : "Not-Done"
      else if (type == 'colorAssesment') return (data && data.colorComplete) ? "Done" : "Not-Done"
    }




  }



  getFilteredCandidates() {
    let tempStatus = []
    console.log("value of selected candidate", this.selectedCandidates);

    if (this.selectedCandidates.length > 0) {
      this.selectedCandidates.forEach(candidate => {
        let index = _.findIndex(this.candidateStatusCopy, function (o) { return o.userId == candidate.userId })
        if (index > -1) {
          tempStatus.push(this.candidateStatusCopy[index])
        }
      })
      this.candidateStatus = tempStatus
      this.candidates = this.selectedCandidates
      console.log("----------selectedCandidates----------", this.candidateStatus)
    }
    else {
      this.candidates = this.candidatesCopy
      this.candidateStatus = this.candidateStatusCopy
    }
  }


  // UTILITY
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { data });
    return dialogRef.afterClosed();
  }


  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }


  // API
  getCandidates() {
    this._mpJobService.getAllCandidateList(this.jobId).subscribe(res => {
      console.log('res ====of===all list of user', res)
      this.candidates = res
      this.candidatesForFilter = res
      this.candidatesCopy = res
    })
  }


  getCandidateMedicalStatus() {
    this._mpJobService.getCandidateMedicalStatus(this.jobId).subscribe(res => {
      console.log('res === of medical candidates', res)
      console.log("what is the display namae daaata", this.formParts);

      this.candidateStatus = res
      this.candidateStatusCopy = JSON.parse(JSON.stringify(res))
      this.loading = false
    })
  }

  updateResult() {
    this._medicalFormService.updateResult(this.resultsArray).subscribe(res => {
      console.log("res in controller", res)
      this.resultsArray = []
      this.openSnackBar("Result Saved Successfully", "OK")
    })
  }

  downloadStatus() {
    this.loading = true
    let obj = {
      job: this.job,
      candidateStatus: this.candidateStatus,
      formParts: this.formParts,
      csvType: 'medicalStatus'
    }

    this.getLatestData().then(() => {

      this._downloadService.downloadCSV(obj).subscribe((csvResponse) => {
        console.log("hello here is the reponse of csvResponse .....", csvResponse)
        this.loading = false
        const downloadLink = document.createElement("a");
        if (csvResponse && csvResponse.data) {
          this._utilityService.handleSnackBar({ msg: "CSV download Successfully!", button: "Ok" })
          downloadLink.href = csvResponse.data;
          downloadLink.click();

        }
      }, (error) => {
        this.loading = false
        this._utilityService.handleSnackBar({ msg: "CSV download Fail!", button: "Ok" })
        console.log("SOME error occure ===>", error)
      })

    })
  }
  getLatestData() {
    return new Promise((resolve) => {
      this._mpJobService.getCandidateMedicalStatus(this.jobId).subscribe(res => {
        console.log('res === of medical candidates', res)
        console.log("what is the display namae daaata", this.formParts);

        this.candidateStatus = res
        resolve(this.candidateStatus)
        this.candidateStatusCopy = res
        this.loading = false
      })
    })

  }

}